import { useState } from 'react'
import { useView } from '@10000/react'
import { AddPill, Body, Box, Button, Dialog, H4, TeamLeaderDialog, UserPill } from '../../widgets'

export const TeamLeadSelect = ({ superUserMode, selectedLeaders = [], onLeadersSelected, newLeaders, onNewLeaderSelected }) => {
  const { users, user } = useView('tenant')
  const admin = superUserMode || user?.admin

  const [leaderDialogOpen, setLeaderDialogOpen] = useState(false)
  const leaderUsers = users.filter(user => (selectedLeaders.includes(user.id) || selectedLeaders.includes(user.email)))

  const [removeLeaderDialogOpen, setRemoveLeaderDialogOpen] = useState(false)
  const [leaderRemoving, setLeaderRemoving] = useState({
    userKey: '',
    display: '',
    existing: false
  })

  const removeLeader = () => {
    if(leaderRemoving.existing) {
      onLeadersSelected(selectedLeaders.filter(user => user !== leaderRemoving.userKey))
    } else {
      onNewLeaderSelected(newLeaders.filter(user => user !== leaderRemoving.userKey))
    }
    setRemoveLeaderDialogOpen(false)
    setLeaderRemoving({
      userKey: '',
      display: '',
      existing: false
    })
  }

  const openRemoveLeader = (leader) => {
    setLeaderRemoving(leader)
    setRemoveLeaderDialogOpen(true)
  }

  const leadAdded = (leader, isNewLeaderEmail) => {
    if(leader) {
      isNewLeaderEmail
        ? onNewLeaderSelected([...newLeaders, leader])
        : onLeadersSelected([...selectedLeaders, leader])
    }
  }

  return (
    <Box gap={8} column>
      <Body alt bold>Team Leaders</Body>
      {leaderUsers.map((user, index) =>
        <UserPill
          action={!user?.onboard}
          invited
          key={index}
          user={user}
          actionText={admin ? "Remove" : undefined}
          blackListBackgrounds={['white']}
          onClick={admin ? () => openRemoveLeader({ userKey: user.id, display: user?.name || user?.email, existing: true }) : undefined}
        />
      )}
      {newLeaders.map((email, index) =>
        <UserPill
          key={index}
          user={{ email }}
          action
          actionText="Remove"
          onClick={() => openRemoveLeader({ userKey: email, display: email, existing: false })}
        />
      )}
      {admin &&
        <AddPill
          text={selectedLeaders.length > 0 ? 'Add leader' : 'Select'}
          onClick={() => setLeaderDialogOpen(true)}
        />
      }

      <Dialog showControls={false} open={removeLeaderDialogOpen} onClose={() => setRemoveLeaderDialogOpen(false)} mobileBackground="white" mobileDrawer={false}>
        <H4 color="black">Remove team leader</H4>
        <Body color="black" align="center">Are you sure you would like to remove {leaderRemoving.display} from this team?</Body>
        <Box fullWidth gap={8}>
          <Button light fullWidth onClick={() => setRemoveLeaderDialogOpen(false)}>Cancel</Button>
          <Button fullWidth onClick={() => removeLeader()}>Remove</Button>
        </Box>
      </Dialog>
      <TeamLeaderDialog
        users={users}
        newLeaders={newLeaders}
        leaders={selectedLeaders}
        open={leaderDialogOpen}
        onSelected={leadAdded}
        onClose={() => setLeaderDialogOpen(false)}
        showControls={false}
      />
    </Box>
  )
}